import { useEffect, useState } from 'react';

import { Box } from '@mui/system';
import { SearchOutlined } from '@mui/icons-material';

import CourseList from './CourseList';
import useLogin from '../../hooks/useLogin';
import { titleSx, contentSx } from './styles';
import { getAllCourses } from '../../api/apis';
import { type Course, type User } from '../../utils/type';
import useCurrentUser from '../../hooks/useCurrentUser';
import Navigator, { NAVIGATOR_HEIGHT } from '../../components/Navigator';
import Copyright, { COPYRIGHT_HEIGHT } from '../../components/Copyright';

import { useTranslation } from 'react-i18next';

function isMandatoryCourse (course: Course, user: User | null) {
  let isMandatory = true;

  if (user) {
    const departments = user.department.split('!');
    course.mandatory.forEach(m => {
      if (departments.includes(m)) {
        isMandatory = true;
      }
    });
  }

  return isMandatory;
}

export const CoursePage = () => {
  const { t } = useTranslation();
  useLogin();
  const [courses, setCourses] = useState<Course[]>([]);
  const [filter, setFilter] = useState('');
  const user = useCurrentUser();

  useEffect(() => {
    (async () => {
      const response = await getAllCourses();
      const courseList = response.data.course;

      setCourses(
        courseList.sort((a: Course, b: Course) => {
          if (a.category1 > b.category1) return 1;
          else if (a.category1 === b.category1) return 0;
          return -1;
        }),
      );
    })();
  }, []);

  return (
    <main style={{ height: '100%' }}>
      <Navigator />
      <div
        style={{
          display: 'flex',
          height: `calc(100% - ${NAVIGATOR_HEIGHT + COPYRIGHT_HEIGHT}px - 200px)`,
        }}
      >
        {/* Courses List */}
        <Box sx={contentSx}>
          <Box sx={titleSx}>
            <div className="title">{t('Courses / Quizzes List')}</div>

            <div style={{ position: 'relative' }}>
              <input className="course-search" type="text" onChange={e => { setFilter(e.target.value); }} />
              <SearchOutlined
                color="primary"
                sx={{
                  position: 'absolute',
                  right: '10px',
                  top: '8px',
                  fontSize: '18px',
                }}
              />
            </div>

            {/* <div className="completed">
              <span className="legend" />
              <span>10 Completed</span>
            </div>
            <div className="processing">
              <span className="legend" />
              <span>2 Processing</span>
            </div> */}
          </Box>

          <CourseList
            courses={courses
              .filter(c => isMandatoryCourse(c, user))
              .filter(c => (filter === '' ? true : c.category1.includes(filter)))}
          />
        </Box>

        {/* History and Badges */}
        {/* <Box sx={infoSx}>
          <CourseHistories courses={courses} />
          <CourseBadges />
        </Box> */}
      </div>
      <Copyright />
    </main>
  );
};

export default CoursePage;
